import React, { useEffect, useContext } from "react";

import GlobalContext from "../../context/GlobalContext";
import Header from "../Header";
import Footer from "../Footer";

const PageWrapper = ({ children, headerDark = false, footerDark = false }) => {
  const gContext = useContext(GlobalContext);

  useEffect(() => {
    if (headerDark) {
      gContext.goHeaderDark();
    } else {
      gContext.goHeaderLight();
    }

    if (footerDark) {
      gContext.goFooterDark();
    } else {
      gContext.goFooterLight();
    }
  }, [gContext, headerDark, footerDark]);

  return <>
    <Header isDark={gContext.headerDark} />

    {children}

    <Footer isDark={gContext.footerDark} />
  </>;
};

export default PageWrapper;
